
import { Grid, Typography } from "@mui/material"




export const TituloNormalScren = ({ titulo, tamanio='25', top=0, bottom=0, centro=true }) => {

    return (

        <Grid item sx={{width:'100%', display:'flex', justifyContent: centro ? 'center' : 'start', alignItems:'center', mt:top, mb:bottom}}>
            <Typography sx={{fontSize:`${tamanio}px`, fontWeight:'bold'}}>{ titulo }</Typography>
        </Grid>

    )

}
